import PeopleIcon from '@mui/icons-material/People';
import React from 'react';
import Controls from '../../components/Slider/Controls';
import Header from '../../components/Slider/Header';
import SplitSelection from '../../components/SplitSelection';
import CompanyLocations from './CompanyLocations';
import NewContact from './NewContact';
import NewOrExistingEndUser from './NewOrExistingEndUser';
import SelectContact from './SelectContact';

const NewOrExistingContact = ({onBack, onNext}) => (
  <>
    <Header>New or Existing?</Header>
    <SplitSelection
      sections={[
        {
          title: 'Contact',
          icon: <PeopleIcon/>,
          buttons: [
            {
              label: 'Select An Existing Contact',
              onClick: () => onNext({type: SelectContact.type, id: SelectContact.type})
            },
            {
              label: 'Create a New Contact',
              onClick: () => onNext({type: NewContact.type, id: NewContact.type})
            },
          ]
        }
      ]}
    />
    <Controls
      onBack={() => onBack({type: CompanyLocations.type, id: CompanyLocations.type})}
      onNext={() => onNext({type: NewOrExistingEndUser.type, id: NewOrExistingEndUser.type})}
      nextLabel="Skip to End User"
    />
  </>
);

NewOrExistingContact.type = 'NEW_OR_EXISTING_CONTACT';

export default NewOrExistingContact;
